import { useAppDispatch, useAppSelector } from '@/config/hooks';
import { getCurrentUser } from '@/services/auth.service';
import { getFloorsByBuilding } from '@/services/floor.service';
import { useTranslation } from 'react-i18next';
import { getUsers } from '@/services/user.service';
import frFR from 'rsuite/locales/fr_FR';

import { ArrowLeftLine, ArrowRightLine, Trash } from '@rsuite/icons';
import {
  format,
  isAfter,
  isBefore,
  isEqual,
  isSameDay,
  isToday,
  startOfDay,
  subDays
} from 'date-fns';
import React, { useEffect, useRef, useState } from 'react';
import { LuCalendarDays, LuCircleParking } from 'react-icons/lu';
import {
  Button,
  Heading,
  IconButton,
  Panel,
  Stack,
  SelectPicker,
  Modal,
  Form,
  DatePicker,
  TagPicker,
  Input,
  InputGroup,
  Message,
  useToaster,
  Calendar,
  Avatar,
  Loader,
  Whisper,
  Tooltip,
  Card,
  Popover,
  Placeholder,
  Tag,
  RadioGroup,
  Radio
} from 'rsuite';
import { getDesksByFloor } from '@/services/desk.service';
import { VscTrash } from 'react-icons/vsc';
import { MdEvent, MdGroup, MdOutlineDirectionsCarFilled } from 'react-icons/md';
import { IoIosArrowBack, IoIosArrowForward, IoMdInformationCircleOutline } from 'react-icons/io';
import { FaUserClock } from 'react-icons/fa';
import ConfirmModal from '@/components/ConfirmModal';
// import './style.less';
import { PiOfficeChairBold } from 'react-icons/pi';
import {
  addGuestReservation,
  deleteAdminOperation,
  fetchFloorReservations
} from '@/services/operation.service';
import { TbUser } from 'react-icons/tb';

const Schedule = ({ type, selectedFloor, setSelectedFloor }) => {
  const dispatch = useAppDispatch();

  const userConnected = getCurrentUser();
  const toaster = useToaster();

  const buildings = useAppSelector((state: any) => state.building?.data);
  const loadingBuildings = useAppSelector((state: any) => state.building?.loading);
  const loading = useAppSelector((state: any) => state.floor?.loading);

  const floors = useAppSelector((state: any) => state.floor?.data)
    .filter(item => item.type == type)
    .map(item => ({ ...item, value: item._id, label: item.name }));

  const resources = useAppSelector((state: any) => state.desk?.data)?.filter(
    item => item.type == (type == 'office' ? 'desk' : type == 'parking' ? 'spot' : 'meeting')
  );
  const loadingResources = useAppSelector((state: any) => state.desk?.loading);

  const operations = useAppSelector((state: any) => state.operation.data);

  const users = useAppSelector((state: any) => state.users.data);
  const bookings = useAppSelector((state: any) => state.operation.userData);
  const loadingBookings = useAppSelector((state: any) => state.operation.userDataLoading);

  const [showCalendar, setShowCalendar] = useState(false);
  const [selectedWeek, setSelectedWeek] = useState(generateWeek(new Date()));
  const [selectedDate, setSelectedDate] = useState(new Date());
  // const [selectedFloor, setSelectedFloor] = useState(null);

  const [showModal, setShowModal] = useState<any>({ open: false });

  const [selectedBuilding, setSelectedBuilding] = useState(null);
  const [bookFor, setBookFor] = useState('guest');

  const [selectedSlots, setSelectedSlots] = useState([]);
  const [isSelecting, setIsSelecting] = useState(false);
  const gridRef = useRef(null);
  const schedulerRef = useRef(null);
  const [loadingBooking, setLoadingBooking] = useState(false);

  const [formValue, setFormValue] = useState<any>({
    date: null,
    slot: '',
    desk: '',
    email: '',
    userName: ''
  });

  const [confirmDialog, setConfirmDialog] = useState<any>({
    open: false,
    title: '',
    subtitle: '',
    loading: false
  });

  const scrollContainerRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = event => {
      if (schedulerRef.current && !schedulerRef.current.contains(event.target)) {
        setSelectedSlots([]);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  useEffect(() => {
    selectedFloor && dispatch(getDesksByFloor(selectedFloor._id));
  }, [selectedFloor]);

  useEffect(() => {
    if (buildings?.length > 0) {
      setSelectedBuilding(buildings[0]?._id);
    }
  }, [buildings]);

  useEffect(() => {
    selectedBuilding && dispatch(getFloorsByBuilding(selectedBuilding));
  }, [selectedBuilding, type]);

  useEffect(() => {
    if (floors?.length > 0 && !selectedFloor) {
      setSelectedFloor(floors[0]);
    }
  }, [floors]);

  useEffect(() => {
    dispatch(getUsers());
  }, []);

  useEffect(() => {
    selectedFloor &&
      selectedWeek?.length > 0 &&
      dispatch(
        fetchFloorReservations(
          selectedFloor?._id,
          format(selectedWeek[0], 'yyyy-MM-dd'),
          format(selectedWeek[selectedWeek.length - 1], 'yyyy-MM-dd')
        )
      );
  }, [selectedWeek, selectedFloor]);

  // useEffect(() => {
  //   rooms &&
  //     rooms.length > 0 &&
  //     dispatch(
  //       getRoomsOperations(
  //         Array.from(rooms, ({ _id }) => _id),
  //         selectedDate
  //       )
  //     );
  // }, [rooms, selectedDate]);

  const canDelete = (dateStr, slot) => {
    const today = startOfDay(new Date());
    const targetDate = startOfDay(new Date(dateStr));

    const now = new Date();
    const currentHour = now.getHours();

    if (isAfter(targetDate, today)) return true;

    if (isEqual(targetDate, today)) {
      if (slot === 'PM' && currentHour < 17) return true;
      if (slot === 'AM' && currentHour < 11) return true;
    }

    return false;
  };

  const renderSlot = (resource, date, slot) => {
    const operation = operations?.find(
      item =>
        item.desk?._id == resource?._id &&
        item.timeslot == slot &&
        isEqual(startOfDay(new Date(date)), startOfDay(new Date(item.reservationdate)))
    );
    if (!operation) {
      return '';
    }

    return (
      <div
        className="reservation-card"
        style={{
          background:
            operation.status == 'ACTIVE'
              ? '#fffae6'
              : operation.status == 'ENDED'
              ? '#e5faef'
              : // : 'rgba(121, 168, 218, 0.7)',
                '#e5f6ff',
          padding: '10px',
          borderRadius: '8px',

          zIndex: 10
        }}
      >
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            fontSize: 12,
            fontWeight: 'bold',
            color: '#686969'
          }}
        >
          {operation.user?.photo ? (
            <Avatar
              circle
              src={process.env.REACT_APP_IMAGE_URL + operation.user?.photo}
              alt={operation.user.firstname}
              size="xs"
              style={{ marginRight: 5 }}
            />
          ) : (
            <Avatar circle size="xs" style={{ marginRight: 5 }} />
          )}
          <span>
            {operation.user?.firstname} {operation.user?.lastname || operation?.guest}
          </span>
        </div>

        <Stack justifyContent="space-between" style={{ marginTop: 3 }}>
          <p
            style={{
              fontSize: 12,
              margin: 0,

              color: '#686969'
            }}
          >
            <span
              style={{
                height: '8px',
                width: '8px',
                backgroundColor:
                  operation.status == 'ACTIVE'
                    ? '#e49757'
                    : operation.status == 'ENDED'
                    ? '#549272'
                    : '#527da1',
                borderRadius: '50%',
                display: 'inline-block'
              }}
            ></span>{' '}
            {operation.status == 'ACTIVE'
              ? 'Booked'
              : operation.status == 'ENDED'
              ? 'Checked in'
              : '#Checked out'}
          </p>
          {operation.guest ? (
            // <Tag style={{ backgroundColor: '#99b5cb', color: '#fff' }}>Guest</Tag>
            <p
              style={{
                fontSize: 12,
                margin: 0,
                // color:
                //   operation.status == 'ACTIVE'
                //     ? '#e49757'
                //     : operation.status == 'ENDED'
                //     ? '#549272'
                //     : '#527da1'
                color: '#686969'
              }}
            >
              Guest
            </p>
          ) : (
            ''
          )}{' '}
        </Stack>
        {/* <Tag style={{ backgroundColor: '#99b5cb', color: '#fff' }}>Checked out</Tag> */}
        <Stack justifyContent="space-between">
          <p
            style={{
              fontSize: 12,
              margin: 0,
              // color:
              //   operation.status == 'ACTIVE'
              //     ? '#e49757'
              //     : operation.status == 'ENDED'
              //     ? '#549272'
              //     : '#527da1'
              color: '#686969'
            }}
          >
            {slot}{' '}
          </p>{' '}
          <Stack spacing={2} alignItems="center">
            {operation.guest && (
              // <Whisper
              //   trigger="hover"
              //   placement="left"
              //   container={() => scrollContainerRef.current}
              //   speaker={
              //     // <Popover style={{ width: 200, padding: 10 }}>
              //     //   <div>
              //     //     <p style={{ fontSize: 13, margin: 0, fontWeight: 'bold' }}>
              //     //       {operation?.owner?.firstname} {operation?.owner?.lastname}
              //     //     </p>
              //     //   </div>
              //     // </Popover>
              //     <Tooltip>
              //       This is a help <i>tooltip</i> .
              //     </Tooltip>
              //   }
              // >
              //   <TbUser />
              // </Whisper>
              <Whisper
                trigger="hover"
                placement="left"
                // container={() => scrollContainerRef.current}
                preventOverflow
                // positionFixed
                speaker={
                  <Popover style={{ padding: 10 }}>
                    <div>
                      <p style={{ fontSize: 13, margin: 0, color: '#4b4b4b' }}>
                        Booked by{' '}
                        <b>
                          {operation?.owner?.firstname} {operation?.owner?.lastname}
                        </b>
                      </p>
                    </div>
                  </Popover>
                }
              >
                <span style={{ cursor: 'pointer' }}>
                  <TbUser />
                </span>
              </Whisper>
            )}
            {canDelete(operation.reservationdate, operation.timeslot) && (
              <IconButton
                appearance="subtle"
                circle
                size="xs"
                icon={<Trash color="#686969" />}
                onClick={e => {
                  e.stopPropagation();
                  setConfirmDialog({
                    open: true,
                    title: 'Are you sure to delete this reservation ?',
                    subtitle: '',
                    onConfirm: () => {
                      handleDelete(operation._id);
                    }
                  });
                }}
              />
            )}{' '}
          </Stack>
        </Stack>
      </div>
    );
  };

  const handleDateSelect = date => {
    const week = generateWeek(date);
    setSelectedWeek(week);
    // setSelectedDate(date);
    setShowCalendar(false);
  };

  const handleNextWeek = () => {
    const nextMonday = new Date(selectedWeek[selectedWeek.length - 1]);
    nextMonday.setDate(nextMonday.getDate() + 7);
    setSelectedWeek(generateWeek(nextMonday));
  };

  const handlePrevWeek = () => {
    const prevSunday = new Date(selectedWeek[0]);
    prevSunday.setDate(prevSunday.getDate() - 7);
    setSelectedWeek(generateWeek(prevSunday));
  };
  const { t } = useTranslation();

  const handleDelete = async id => {
    try {
      setConfirmDialog(prevDialog => ({ ...prevDialog, loading: true }));
      const result = await dispatch(deleteAdminOperation(id));
      console.log('result', result);
      if (result.status === 200) {
        toaster.push(
          <Message type="success" duration={5000} showIcon>
            {t('Deleted Successfully.')}
          </Message>,
          { placement: 'topCenter' }
        );
        setSelectedSlots([]);
        dispatch(
          fetchFloorReservations(
            selectedFloor?._id,
            format(selectedWeek[0], 'yyyy-MM-dd'),
            format(selectedWeek[selectedWeek.length - 1], 'yyyy-MM-dd')
          )
        );
      } else {
        toaster.push(
          <Message type="error" duration={5000} showIcon>
            {t(result.message)}
          </Message>,
          { placement: 'topCenter' }
        );
      }
      setConfirmDialog({ open: false, loading: false });
    } catch (error) {}
  };

  const isTodayPM = () => {
    const now = new Date();
    const hour = now.getHours();
    return hour >= 12;
  };

  const handleBook = async () => {
    try {
      const desk = showModal.resource;
      const date = showModal.date;

      setLoadingBooking(true);
      if (formValue?.slot?.length == 0) {
        setLoadingBooking(false);
        toaster.push(
          <Message type="warning" duration={5000} showIcon>
            {t('Slot is required')}
          </Message>,
          { placement: 'topCenter' }
        );
        return;
      }

      if (
        !formValue?.email ||
        formValue?.email?.length == 0 ||
        !formValue.userName ||
        formValue.userName?.length == 0
      ) {
        setLoadingBooking(false);
        toaster.push(
          <Message type="warning" duration={5000} showIcon>
            {t('Fill guest information')}
          </Message>,
          { placement: 'topCenter' }
        );
        return;
      }

      if (formValue.slot == 'FULL') {
        const dataAM = {
          type: desk?.type,
          timeslot: 'AM',
          Email: formValue.email,
          user: formValue.userName,
          desk: desk?._id,
          reservationdate: date
        };
        const dataPM = {
          type: desk?.type,
          timeslot: 'PM',
          Email: formValue.email,
          user: formValue.userName,
          desk: desk?._id,
          reservationdate: date
        };
        const resAM = await addGuestReservation(dataAM);
        if (resAM.status == 200) {
          if (resAM.data && resAM.data.status == 201) {
            setLoadingBooking(false);

            toaster.push(
              <Message type="error" duration={5000} showIcon>
                {t(resAM.data.message)}
              </Message>,
              { placement: 'topCenter' }
            );
            return;
          }
          const resPM = await addGuestReservation(dataPM);
          if (resPM.status == 200) {
            toaster.push(
              <Message type="success" duration={5000} showIcon>
                {t('Booked successfully')}
              </Message>,
              { placement: 'topCenter' }
            );
          } else {
            toaster.push(
              <Message type="success" duration={5000} showIcon>
                {t('Booked successfully only for AM')}
              </Message>,
              { placement: 'topCenter' }
            );
          }
          dispatch(
            fetchFloorReservations(
              selectedFloor?._id,
              format(selectedWeek[0], 'yyyy-MM-dd'),
              format(selectedWeek[selectedWeek.length - 1], 'yyyy-MM-dd')
            )
          );
        } else {
          toaster.push(
            <Message type="error" duration={5000} showIcon>
              {t(resAM.message)}
            </Message>,
            { placement: 'topCenter' }
          );
        }
      } else {
        const data = {
          type: desk?.type,
          timeslot: formValue.slot,
          Email: formValue.email,
          user: formValue.userName,
          desk: desk,
          reservationdate: date
        };
        const res = await addGuestReservation(data);
        if (res.status == 200) {
          if (res.data && res.data.status == 201) {
            setLoadingBooking(false);
            toaster.push(
              <Message type="error" duration={5000} showIcon>
                {t(res.data.message)}
              </Message>,
              { placement: 'topCenter' }
            );
            return;
          }
          toaster.push(
            <Message type="success" duration={5000} showIcon>
              {t('Booked successfully')}
            </Message>,
            { placement: 'topCenter' }
          );
          dispatch(
            fetchFloorReservations(
              selectedFloor?._id,
              format(selectedWeek[0], 'yyyy-MM-dd'),
              format(selectedWeek[selectedWeek.length - 1], 'yyyy-MM-dd')
            )
          );
        } else {
          toaster.push(
            <Message type="error" duration={5000} showIcon>
              {t(res.message)}
            </Message>,
            { placement: 'topCenter' }
          );
        }
      }

      setFormValue({});

      setLoadingBooking(false);
      setShowModal({ open: false });
    } catch (e) {
      setLoadingBooking(false);
      toaster.push(
        <Message type="error" duration={5000} showIcon>
          {t(e.message)}
        </Message>,
        { placement: 'topCenter' }
      );
    }
  };

  return (
    <div className="resource-scheduler">
      <Panel
        style={{
          // padding: 10,
          marginBottom: 5
        }}
      >
        <Form
          style={{
            display: 'flex',
            alignItems: 'flex-start',
            flexDirection: 'row',
            gap: 50
          }}
        >
          <Form.Group>
            <Form.ControlLabel>{t('Office')}</Form.ControlLabel>
            <SelectPicker
              data={buildings?.map(building => ({
                ...building,
                value: building?._id,
                label: building?.address
              }))}
              searchable={false}
              style={{ width: 200, backgroundColor: 'transparent' }}
              placeholder={t('Select Building')}
              value={selectedBuilding}
              onChange={setSelectedBuilding}
              loading={loadingBuildings}
            />
          </Form.Group>

          {loading ? (
            <Stack direction="row" spacing={10} justifyContent="flex-start">
              <Placeholder.Graph active style={{ height: 50 }} />
              <Placeholder.Graph active style={{ height: 50 }} />
              <Placeholder.Graph active style={{ height: 50 }} />
            </Stack>
          ) : (
            <Stack direction="row" spacing={10} justifyContent="flex-start">
              {floors?.map(floor => {
                return (
                  <Card
                    key={floor._id}
                    bordered
                    style={{
                      minWidth: 130,
                      height: 50,
                      textAlign: 'center',
                      background: 'none',
                      borderRadius: 10,
                      paddingRight: 15,
                      paddingLeft: 15,
                      backgroundColor:
                        selectedFloor?.floor_num === floor.floor_num
                          ? 'rgb(216, 227, 238)'
                          : 'transparent',
                      marginTop: 10,
                      cursor: 'pointer'
                      // boxShadow: '0px 4px 10px rgba(0, 0, 0, 0.1)'
                    }}
                    onClick={() => {
                      setSelectedFloor(floor);
                    }}
                  >
                    <Stack justifyContent="space-between" alignItems="center">
                      <h5 style={{ fontSize: 14, margin: '8px 0', fontWeight: 'bold' }}>
                        {floor.name}
                      </h5>
                    </Stack>
                  </Card>
                );
              })}
            </Stack>
          )}
        </Form>
        <div style={{ display: 'flex', gap: 20, marginTop: 40 }}>
          <div
            className="scheduler "
            style={{
              width: '100%'
            }}
          >
            <div
              className="scheduler"
              style={{
                display: 'grid',
                height: '20px',
                gridTemplateColumns: `120px repeat(${selectedWeek.length + 1}, 1fr)`,
                gap: '2px',
                background: 'transparent',
                padding: '2px',
                borderRadius: '8px',
                marginTop: '10px',
                justifyItems: 'center'
              }}
            >
              <div style={{ display: 'flex', alignItems: 'center', gap: 20 }}>
                <Button onClick={() => setShowCalendar(true)} appearance="subtle">
                  <LuCalendarDays />
                </Button>
                <Heading level={5}> {t(format(selectedWeek[0], 'MMMM'))}</Heading>
                <IconButton
                  appearance="subtle"
                  circle
                  icon={<ArrowLeftLine />}
                  onClick={handlePrevWeek}
                />
              </div>
              {selectedWeek.map((date, index) => (
                <div
                  key={index}
                  style={{
                    textAlign: 'center',
                    fontSize: 15,
                    color: isToday(date) ? '#0d47a1' : '',

                    fontWeight: isToday(date) || isSameDay(date, selectedDate) ? 'bold' : 'normal',
                    display: 'inline-block'
                  }}
                >
                  {t(format(date, 'EEE'))} <br></br> {format(date, 'dd')}
                </div>
              ))}
              <div>
                <IconButton
                  appearance="subtle"
                  circle
                  icon={<ArrowRightLine />}
                  onClick={handleNextWeek}
                />
              </div>
            </div>
            {loadingResources ? (
              <div
                style={{
                  marginTop: 50,
                  textAlign: 'center'
                }}
              >
                <Loader />
              </div>
            ) : (
              <div style={{ marginTop: 30, height: '500px', overflowY: 'auto' }}>
                {resources?.map((resource, index) => (
                  <div
                    key={index}
                    className="scheduler"
                    style={{
                      position: 'relative',
                      display: 'grid',
                      // height: '100px',
                      gridTemplateColumns: `120px repeat(${selectedWeek.length}, 1fr)`,
                      gap: '2px',
                      background: '#ffffff',
                      padding: '5px',
                      borderRadius: '8px',
                      marginTop: '10px',
                      width: '90%',
                      minHeight: '120px'
                    }}
                  >
                    <div className="room-name">
                      <Stack alignItems="center" spacing={5}>
                        {resource.type == 'desk' ? (
                          <PiOfficeChairBold />
                        ) : (
                          <MdOutlineDirectionsCarFilled />
                        )}
                        {resource.name}
                      </Stack>
                      <p style={{ fontSize: 12, color: '#777', margin: 0 }}>
                        {resource.zone?.floor?.name}
                      </p>
                    </div>

                    {selectedWeek.map((date, index) => {
                      const today = startOfDay(new Date());
                      const targetDate = startOfDay(new Date(date));
                      const isPast = isBefore(targetDate, today);

                      const isFullBooked =
                        operations.filter(
                          item =>
                            item.desk._id === resource._id &&
                            isEqual(targetDate, startOfDay(new Date(item.reservationdate)))
                        )?.length > 1;

                      // const isFullBooked = false;

                      return (
                        <div
                          key={index}
                          // className={`${time.includes('30') ? 'half-cell' : 'cell'}`}
                          onClick={e => {
                            const bookedSlot = operations.find(
                              item =>
                                item.desk._id === resource._id &&
                                isEqual(date, startOfDay(new Date(item.reservationdate)))
                            );
                            isFullBooked || isPast
                              ? e.preventDefault()
                              : setShowModal({
                                  open: true,
                                  resource: resource,
                                  date,
                                  bookedSlot: bookedSlot
                                });
                          }}
                          className={`cell ${isPast ? 'disabled' : ''} 
                        `}
                        >
                          <div className=""> {renderSlot(resource, date, 'AM')} </div>

                          <div
                            style={{
                              borderTop: '1px solid var(--rs-border-primary)',
                              marginTop: 5,
                              marginBottom: 5
                            }}
                          />

                          <div className=""> {renderSlot(resource, date, 'PM')} </div>
                        </div>
                      );
                    })}

                    {/* {operations
                      ?.filter(op => op.desk?._id === resource._id)
                      ?.map((operation, idx) => {
                        console.log('reservation', operation);

                        const cellWidth = 120;
                        const startIndex = selectedWeek.findIndex(date =>
                          isEqual(
                            startOfDay(new Date(date)),
                            startOfDay(new Date(operation.reservationdate))
                          )
                        );
                        const left = 150 + startIndex * cellWidth;
                        return (
                          <div
                            key={idx}
                            // className="reservation-card"
                            style={{
                              position: 'absolute',

                              top: 0,

                              left: `${left}px`,
                              width: `${cellWidth}px`,
                              height: '80%',
                              background: 'rgba(121, 168, 218, 0.7)',
                              color: '#4b4b4b',
                              padding: '10px',
                              borderRadius: '8px',
                              // marginLeft: '10px',
                              // marginRight: '10px',
                              // textAlign: 'center',
                              // display: 'flex',
                              // flexWrap: "wrap",
                              // alignItems: 'center',
                              // justifyContent: 'center',
                              zIndex: 10
                            }}
                          >
                            <Stack spacing={5} wrap>
                              {operation.user.photo ? (
                                <Avatar
                                  circle
                                  src={process.env.REACT_APP_IMAGE_URL + operation.user.photo}
                                  alt={operation.user.firstname}
                                  size="xs"
                                />
                              ) : (
                                <Avatar circle size="xs" />
                              )}

                              <p style={{ fontSize: 12, margin: 0, fontWeight: 'bold' }}>
                                {operation.user.firstname} {operation.user.lastname}
                              </p>
                            </Stack>

                            <p style={{ fontSize: 12, margin: 0 }}>
                              {format(new Date(operation.reservationdate), 'dd-MM-yyyy')} -{' '}
                              {operation.timeslot}
                            </p>
                          </div>
                        );
                      })} */}
                  </div>
                ))}
              </div>
            )}
          </div>

          {/* <div style={{ width: '20%' }}>
            <Form
              style={{
                display: 'flex',
                alignItems: 'flex-start',
                flexDirection: 'column'
              }}
            >
              <Form.Group>
                <Form.ControlLabel>Office</Form.ControlLabel>
                <SelectPicker
                  data={buildings?.map(building => ({
                    ...building,
                    value: building?._id,
                    label: building?.address
                  }))}
                  searchable={false}
                  style={{ width: 200, backgroundColor: 'transparent' }}
                  placeholder="Select Building"
                  value={selectedBuilding}
                  onChange={setSelectedBuilding}
                  loading={loadingBuildings}
                />
              </Form.Group>

              {loading ? (
                <Stack direction="column" spacing={10} justifyContent="flex-start">
                  <Placeholder.Graph active style={{ height: 50 }} />
                  <Placeholder.Graph active style={{ height: 50 }} />
                  <Placeholder.Graph active style={{ height: 50 }} />
                </Stack>
              ) : (
                <Stack direction="column" spacing={10} justifyContent="flex-start">
                  {floors?.map(floor => {
                    return (
                      <Card
                        key={floor._id}
                        bordered
                        style={{
                          width: 200,
                          height: 50,
                          textAlign: 'center',
                          background: 'none',
                          borderRadius: 10,
                          paddingRight: 15,
                          paddingLeft: 15,
                          backgroundColor:
                            selectedFloor?.floor_num === floor.floor_num
                              ? 'rgb(216, 227, 238)'
                              : 'transparent',
                          marginTop: 10,
                          cursor: 'pointer'
                          // boxShadow: '0px 4px 10px rgba(0, 0, 0, 0.1)'
                        }}
                        onClick={() => {
                          setSelectedFloor(floor);
                        }}
                      >
                        <Stack justifyContent="space-between" alignItems="center">
                          <h5 style={{ fontSize: 14, margin: '8px 0', fontWeight: 'bold' }}>
                            {floor.name}
                          </h5>
                        </Stack>
                      </Card>
                    );
                  })}
                </Stack>
              )}
            </Form>
          </div> */}
        </div>
      </Panel>

      {showModal.open && (
        <Modal
          open={showModal.open}
          onClose={() => {
            setShowModal({ open: false });
            setFormValue({});
          }}
          size="xs"
        >
          <Modal.Header>
            <Modal.Title>
              <strong>
                Book {showModal?.resource?.name} | {showModal.resource.zone?.floor?.name}
              </strong>
              <br />
              {/* <p style={{ fontSize: 12, color: '#777', paddingTop: 5 }}>
                {showModal.resource.zone?.floor?.name}
              </p> */}
              {/* <Tag color="green" style={{ marginTop: 5 }}>
                {showModal.bookedSlot == null
                  ? 'Available'
                  : 'Available only ' + showModal.bookedSlot == 'AM'
                  ? 'PM'
                  : 'AM'}
              </Tag> */}
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div style={{ marginTop: 30 }}>
              <Form fluid formValue={formValue} onChange={value => setFormValue(value)}>
                <Stack justifyContent="space-between" wrap>
                  <Form.Group>
                    <Form.ControlLabel>{t('Date')}</Form.ControlLabel>
                    <DatePicker readOnly value={showModal.date} style={{ width: 150 }} />
                  </Form.Group>
                  <Form.Group>
                    <Form.ControlLabel>{t('Slot')}</Form.ControlLabel>
                    <RadioGroup
                      name="radio-group-inline"
                      inline
                      // defaultValue={
                      //   showModal.bookedSlot == 'AM'
                      //     ? 'PM'
                      //     : showModal.bookedSlot == 'PM'
                      //     ? 'AM'
                      //     : 'FULL'
                      // }
                      onChange={value => {
                        setFormValue(prevFormValue => ({ ...prevFormValue, slot: value }));
                      }}
                    >
                      <Radio
                        value="AM"
                        disabled={
                          showModal.bookedSlot == 'AM' || (isToday(showModal.date) && isTodayPM())
                        }
                      >
                        AM
                      </Radio>
                      <Radio value="PM" disabled={showModal.bookedSlot == 'PM'}>
                        PM
                      </Radio>
                      <Radio
                        value="FULL"
                        disabled={
                          showModal.bookedSlot != null || (isToday(showModal.date) && isTodayPM())
                        }
                      >
                        {t('ALL DAY')}
                      </Radio>
                    </RadioGroup>
                  </Form.Group>
                </Stack>

                {/* <Stack spacing={10} style={{ marginTop: 10 }}>
                  <p>Book for: </p>
                  <RadioGroup
                    inline
                    name="radio-group"
                    defaultValue="myself"
                    onChange={setBookFor}
                    value={bookFor}
                  >
                    <Radio value={'guest'}> Guest</Radio>
                    <Radio value={'member'}> Member</Radio>
                  </RadioGroup>
                </Stack> */}
                {bookFor == 'guest' ? (
                  <>
                    <Form.Group style={{ marginTop: 10 }}>
                      <Form.ControlLabel>Name</Form.ControlLabel>
                      <Form.Control
                        onChange={value => {
                          setFormValue(prevFormValue => ({ ...prevFormValue, userName: value }));
                        }}
                        value={formValue.userName}
                        name="user"
                        // style={{ width: 260 }}
                        block
                      />
                    </Form.Group>{' '}
                    <Form.Group>
                      <Form.ControlLabel>{t('Email')}</Form.ControlLabel>
                      <Form.Control
                        onChange={value => {
                          setFormValue(prevFormValue => ({ ...prevFormValue, email: value }));
                        }}
                        value={formValue.email}
                        name="email"
                        // style={{ width: 260 }}
                        block
                      />
                    </Form.Group>
                  </>
                ) : (
                  <Form.Group style={{ marginTop: 10 }}>
                    <Form.ControlLabel>{t('Members')}</Form.ControlLabel>
                    <Form.Control
                      name="team"
                      accepter={SelectPicker}
                      data={users.map(user => ({
                        ...user,
                        label: user.firstname + ' ' + user.lastname,
                        value: user._id
                      }))}
                      searchable
                      placeholder={t('Select member')}
                      block
                      placement="auto"
                    />
                  </Form.Group>
                )}
              </Form>
            </div>
          </Modal.Body>
          <Modal.Footer>
            <Button
              onClick={() => {
                handleBook();
              }}
              appearance="primary"
              disabled={loadingBooking}
              loading={loadingBooking}
            >
              {t('Confirm')}
            </Button>
            <Button
              onClick={() => {
                setShowModal({ open: false });
                setFormValue({});
              }}
              appearance="subtle"
            >
              {t('Cancel')}
            </Button>
          </Modal.Footer>
        </Modal>
      )}

      <Modal open={showCalendar} onClose={() => setShowCalendar(false)}>
        <Modal.Header>
          <Modal.Title>{t('Choose a Week')}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Calendar
            // bordered
            onSelect={handleDateSelect}
            compact
            weekStart={1}
            showWeekNumbers={true}
            locale={frFR}
          />
        </Modal.Body>
      </Modal>

      {confirmDialog?.open == true && (
        <ConfirmModal confirmDialog={confirmDialog} setConfirmDialog={setConfirmDialog} />
      )}
    </div>
  );
};

export default Schedule;

const generateWeek = date => {
  const start = new Date(date);

  const dayOfWeek = start.getDay();
  const daysToSubtract = dayOfWeek === 0 ? 6 : dayOfWeek - 1;
  start.setDate(date.getDate() - daysToSubtract);

  return Array.from({ length: 7 }, (_, i) => {
    const day = new Date(start);
    day.setDate(start.getDate() + i);
    return day;
  });
};
